import './style.scss'

import { mapGetters, mapState } from 'vuex'
import Title from 'components/Title'
import verifyLeadingSlashLang from 'util/verifyLeadingSlashLang'
import getPathFromUrl from 'util/getPathFromUrl'

export default {
  name: 'Footer',
  computed: {
    ...mapState({
      open: state => state.ui.menuOpen,
      options: state => state.data.data.options
    }),
    ...mapGetters(['getMenu', 'loaded', 'lang', 'otherLangLink', 'getStringTranslation', 'error']),
    sitemapMenu () {
      return this.getMenu('footer_sitemap')
    },
    metaMenu () {
      return this.getMenu('footer_meta')
    },
    otherLangLinkPath () {
      return this.otherLangLink ? getPathFromUrl(this.otherLangLink) : ''
    }
  },
  methods: {
    getTranslation (translationTitle) {
      return this.getStringTranslation(translationTitle)
    }
  },
  render (h) {
    const { sitemapMenu, metaMenu, open, options, loaded, lang, otherLangLinkPath, error } = this
    return (
      loaded
      ? <footer class='Footer'
        hidden={open ? 'hidden' : null}
      >
        <div class='Footer__content'>
          <nav class='Footer__nav Footer__nav--sitemap'>
            <Title class='Footer__title' level={3}>{this.getTranslation('sitemap')}</Title>
            <ul class='Footer__nav-list Footer__nav-list--sitemap'>
              {sitemapMenu && sitemapMenu.items ? (sitemapMenu.items.map(i => (
                <li class='Footer__nav-list-item'>
                  { /* TODO: Get full path (all/them/slugs) */ }
                  <router-link to={verifyLeadingSlashLang(i.object_slug, lang)} class={'Footer__nav-list-item-link'}>
                    {i.title}
                  </router-link>

                  { i.children && i.children.length
                    ? (<ul class='Footer__nav-sublist'>
                    {i.children.map(c => (
                      <li class='Footer__nav-sublist-item'>

                        { /* TODO: Get full path from children, maybe it's better not to assume they're directly nested */ }

                        <router-link to={verifyLeadingSlashLang(`${i.object_slug}/${c.object_slug}`, lang)} class={'Footer__nav-sublist-item-link'}>
                          {c.title}
                        </router-link>

                      </li>
                  ))}
                  </ul>)
                  : null
                  }
                </li>
              ))) : null}
            </ul>
          </nav>

          <div class='Footer__contact'>
            <Title class='Footer__title' level={3}>{options.contact_section_title}</Title>
            <div class='Footer__contact-items'>
              {options.contact_items.map(i => (
                <div class='Footer__contact-item RichText'>
                  <h4>{i.title}</h4>
                  <ul class='Footer__contact-item-list'>
                    <li><a href={`${i.address_link}`} target='blank'>{i.address_text}</a></li>
                    <li><a href={`mailto:${i.email}`}>{i.email}</a></li>
                    <li><a href={`tel:${i.phone_link}`}>T {i.phone_number}</a></li>
                  </ul>
                </div>
              ))}
            </div>

            <div class='Footer__social'>
              {options.social_media_links.map(i => (
                <a class='Footer__social-icon-link' href={i.link} target='_blank' rel='noopener'>
                <img class='Footer__social-icon' src={`/imgs/${i.type}.svg`} alt='Social Media Icon' />
                </a>
              ))}
            </div>
          </div>

        </div>
        <div class='Footer__content'>
          <div class='Footer__copyright'>
            {`${options.copyright_text} ${new Date().getFullYear()}`}
          </div>
          <nav class='Footer__nav Footer__nav--meta'>
            <ul class='Footer__nav-list Footer__nav-list--meta'>
              {metaMenu && metaMenu.items ? (metaMenu.items.map(i => (
                <li class='Footer__nav-list-item Footer__nav-list-item--meta'>

                  { /* TODO: Get full path (all/them/slugs) */ }

                  <router-link to={verifyLeadingSlashLang(i.object_slug, lang)} class={'Footer__nav-list-item-link Footer__nav-list-item-link--meta'}>
                    {i.title}
                  </router-link>

                </li>
              ))) : null}
              {!error
              ? <li class='Footer__nav-list-item Footer__nav-list-item--meta'>
                <router-link to={this.lang === 'de' ? this.$route.fullPath : otherLangLinkPath} class='Footer__nav-list-item-link Footer__nav-list-item-link--meta Footer__nav-list-item--lang-switcher'>
                  DE
                </router-link>
                <router-link to={this.lang === 'en' ? this.$route.fullPath : otherLangLinkPath} class='Footer__nav-list-item-link Footer__nav-list-item-link--meta Footer__nav-list-item--lang-switcher'>
                  EN
                </router-link>
              </li>
              : null}
            </ul>
          </nav>
        </div>
      </footer>
      : null
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Footer/index.js